import { Component } from "react";
import "./Introduction.css";
import { AUbutton } from "../../ui";
import { Link } from "react-router-dom";
import { Path } from "../Routes/Routes";
import Bubbles from "./bubbles.svg";

class Introduction extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
            <div className="Introduction">
              <h2>Welcome to LOOC-C</h2>
              <p>
                LOOC-C allows you to quickly assess options on the land for
                certain projects offered under the Australian Carbon Credit Unit
                (ACCU) scheme.
              </p>
              <p>
                <b>Now updated</b> with plantation forestry methods for New
                South Wales.
              </p>
              <p>
                The <b>Human Induced Regrowth</b> method has been removed from
                LOOC-C with the closing of the method on 30th September 2023.
                More information can be found{" "}
                <a href="https://www.cleanenergyregulator.gov.au/ERF/Choosing-a-project-type/Opportunities-for-the-land-sector/Vegetation-methods/Human-Induced%20regeneration%20of%20a%20permanent%20even-aged%20native%20forest">
                  here
                </a>
                .
              </p>
              <p>LOOC-C data is also available by subscription API.</p>
              <p>
                For more information email the LOOC-C team at{" "}
                <a href="mailto:looc-c@csiro.au">LOOC-C</a>.
              </p>
              <p style={{ fontSize: 12 }}>
                <b>Updated September 2026 </b>
               - We’ve updated LOOC-C. If you notice any issues or unexpected results, please let us know.

              </p>
              <div className="Introduction__cta">
                <AUbutton
                  linkComponent={Link}
                  link={Path.FarmDetails}
                  to={Path.FarmDetails}
                  style={{
                    backgroundColor: "#F37221",
                    border: "3px solid #F37221"
                  }}
                >
                  Explore your options{" >>"}
                </AUbutton>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
            <div className="Introduction__bubbles">
              <img
                className="Introduction__image"
                src={Bubbles}
                alt="Land sector Bubbles"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Introduction;
